export default "__VITE_ASSET__wKvBYL6B__"